<template>
	<section class="section container talk">
		<h1 class="title">{{ talk.talk.title }}</h1>
		<div class="container">
			<b-button class="" style="width:100px; margin-bottom:20px"
			
			@click="goBack()"
			target="_self" 
			outlined
			>
				<b-icon
                    pack="fas"
                    size="large"
                    icon="arrow-left"
					style="margin-top:8px"
                ></b-icon><span class="icon large" style="padding-bottom: 14px; margin-left: 10px; vertical-align: middle;"> back</span>
			</b-button>
		</div>
		<div style="padding:56.25% 0 0 0;position:relative;">
			<iframe :src="'https://player.vimeo.com/video/' + getVideoId(talk.talk.video.url) + '?autoplay=1&title=0&byline=0'" style="position:absolute;top:0;left:0;width:100%;height:100%;" frameborder="0" allow="autoplay; fullscreen" allowfullscreen></iframe>
		</div>
		<p><a target="_blank" :href="talk.talk.video.url">{{talk.talk.title}}</a> from <a target="_blank" href="https://vimeo.com/websummit">Web Summit</a> on <a target="_blank" href="https://vimeo.com">Vimeo</a>.</p>

		
		<div class="content has-text-left">
			<p><span class="has-text-weight-bold">Location:</span> {{talk.talk.location.name}}</p>
			<p><span class="has-text-weight-bold">Date:</span> {{talk.date}}</p>
			<p><span class="has-text-weight-bold">Duration:</span> {{talk.talk.duration}} min</p>

			<p>{{talk.talk.description}}</p>

			<p class="has-text-weight-bold">Attendees:</p>
			<!-- <div v-for="node in talk.talk.participants.nodes" :key="node.id">
				<img :src="node.attendee.avatarUrl" alt="">
				<p>Name: {{node.attendee.name}}</p>
				<p>{{node.attendee.jobTitle}} @ {{node.attendee.companyName}}</p>
				<p>Bio: {{node.attendee.bio}}</p>
			</div> -->
		
			<div class="columns is-multiline is-mobile" v-for="row in Math.ceil(talk.talk.participants.nodes.length / 4)" :key="row.id">
				<div v-for="node in talk.talk.participants.nodes.slice((row - 1) * 4, row * 4)" class="speaker-card column is-one-quarter-desktop is-half-tablet is-full-mobile is-full-height" :key="node.id">
					
					<figure v-if="node.attendee.avatarUrl" class="image"><!-- is-4by3 -->
						<img class="is-rounded speaker-img" :src="node.attendee.avatarUrl" :alt="node.attendee.name" ratio="1by1">
					</figure>
					<p><b>Name:</b> {{node.attendee.name}}</p>
					<p>{{node.attendee.jobTitle}} @ <b>{{node.attendee.companyName}}</b></p>
					<p>Bio: {{node.attendee.bio}}</p>
				</div>
			</div>
		</div>
		
	</section>
</template>

<script>
import all from '@/json/full_parsed.json'


export default {
	data() {
		return {
			id: this.$route.params.id,
			all_data: all,
		}
	},
	computed: {
		talk(){
			return this.all_data[this.id]
		}
	},
	mounted() {

	},
	methods: {
		getTalk(id){
			return this.all_data[id]
		},
		getVideoId(url){
			let stringArray = url.split("/")
			return stringArray[stringArray.length - 1]
		},
		goBack(){
			this.$router.go(-1)
		}
	}
}
</script>

<style>
.speaker-img {
	width: 150px !important;
}
.speaker-card{
	padding: 20px;
	
}

</style>
